<h1 class="text-center without-help text-02-m-light text-01-d-light title">¡Ya casi está!</h1>
<p class="subtitle text-05-m-regular text-07-d-regular">
  {{ question.ToolTip }}
</p>
<div class="form-control input" id="divEmail">
  <label for="input">{{ question.QuestionText }}</label>
  <input
    type="text"
    name="RiskNode"
    id="RiskNode"
    [ngModel]="applyEmailMask()"
    (ngModelChange)="onEmailModelChange($event)"
    (focus)="onEmailFocusField()"
    (input)="(contractType.emailAddress)"
    class="text-input text-09-d-demibold"
    maxlength="255"
    autocomplete="off"
    [class.error]="!isValid" />
  <p class="error-txt error" id="errorEmail" [class.hidden]="isValid">Por favor, introduce una dirección de e-mail correcta</p>
  <button id="btnClose" class="btn solid-main" (click)="saveSectionAnswer()">Guardar</button>
</div>
